import { Utility } from '../utility/utility_controller'

var navshow_hide_safety_offset = 20
var navshowhide_instances = []

var NavShowHide = function (identifier) {
	this.identifier = identifier
	this.$nav_el = jQuery('nav.' + identifier)
	this.suffix = identifier == 'primary' ? '' : '_' + identifier
	this.nav_hide = layData.nav_customizer_properties['nav_hide' + this.suffix]
	this.nav_hidewhenscrollingdown = layData.nav_customizer_properties['nav_hidewhenscrollingdown' + this.suffix]
	this.nav_fadeout_whenscrollingdown = layData.nav_customizer_properties['nav_fadeout_whenscrollingdown' + this.suffix]

	this.max_translate_bottom = -1
	this.max_translate_top = -1

	this.nav_hidewhenscrolling_show_on_mouseover = layData.nav_customizer_properties['nav_hidewhenscrolling_show_on_mouseover' + this.suffix]
	this.nav_position = layData.nav_customizer_properties['nav_position' + this.suffix]
	this.rect = null
	// height_and_space_around is kind of the breakpoint of when to hide nav when scrolling down
	// and when to show it when movin mouse over area
	this.height_and_space_around = null
	this.set_height_and_space_around()
}

NavShowHide.prototype.setRect = function () {
	if(!this.$nav_el[0]) {
		return
	}
	this.rect = this.$nav_el[0].getBoundingClientRect()
}

NavShowHide.prototype.set_height_and_space_around = function () {
	this.setRect()
	if(!this.rect) {
		return
	}
	this.height_and_space_around = this.$nav_el.outerHeight()
	if (this.nav_position.indexOf('top') != -1) {
		this.height_and_space_around += this.rect.top
	} else {
		this.height_and_space_around += window.innerHeight - this.rect.bottom
	}
	// "safety" offset
	this.height_and_space_around += navshow_hide_safety_offset
}

NavShowHide.prototype.show_on_mouseover = function (position) {
	if (!this.nav_hidewhenscrolling_show_on_mouseover) {
		return
	}
	if (this.nav_position.indexOf(position) != -1) {
		this.show()
	}
}

NavShowHide.prototype.show = function () {
	if (this.nav_hidewhenscrollingdown && !this.nav_hide) {
		if (window.lay_lightbox_opened == false || typeof window.lay_lightbox_opened == 'undefined') {
			if (this.$nav_el.hasClass('hidden')) {
				this.$nav_el.removeClass('hidden').css({ transform: '', opacity: '', 'pointer-events': '' })
			}
		}
	}
	if (this.nav_fadeout_whenscrollingdown && !this.nav_hide) {
		if (window.lay_lightbox_opened == false || typeof window.lay_lightbox_opened == 'undefined') {
			if (this.$nav_el.hasClass('hidden')) {
				this.$nav_el.removeClass('hidden').css({ transform: '', opacity: '', 'pointer-events': '' })
			}
		}
	}
	// if(this.nav_fadeout_whenscrollingdown && !this.nav_hide){
	//     if(window.lay_lightbox_opened == false || typeof window.lay_lightbox_opened == "undefined"){
	//         if( this.$nav_el.hasClass('hidden') ){
	//             this.$nav_el.removeClass('hidden').css({'opacity': ''});
	//         }
	//     }
	// }
}

// The desktop nav exists (vs. the mobile burger menu) when the viewport is
// wider than the MENU breakpoint (`phone_menu_breakpoint`). This is a
// different setting from the CONTENT breakpoint (`layData.breakpoint`) that
// `Utility.isDesktopOrTabletSize` is derived from — so the nav show/hide
// must gate on the menu breakpoint, otherwise a viewport that sits between
// the two breakpoints shows the desktop menu but never hides/fades it.
var isDesktopMenuVisible = function () {
	return window.innerWidth > Utility.phoneMenuBreakpoint
}

NavShowHide.prototype.hide = function () {
	if ((this.nav_fadeout_whenscrollingdown || this.nav_hidewhenscrollingdown) && isDesktopMenuVisible() && !this.nav_hide) {
		if (this.nav_fadeout_whenscrollingdown) {
			if (!this.$nav_el.hasClass('hidden')) {
				this.$nav_el.css({ opacity: 0, 'pointer-events': 'none' })
			}
		}

		this.setRect()
		if (this.nav_hidewhenscrollingdown && this.rect) {
			if (!this.$nav_el.hasClass('hidden')) {
				var x = 0
				if (this.nav_position.indexOf('center') != -1) {
					x = '-50%'
				}
				if (this.nav_position.indexOf('top') != -1) {
					var h = this.rect.bottom + navshow_hide_safety_offset
					// on safari mobile, i think because of the top browser bar changing its height when
					// scrolling up and down, sometimes this calculation is off (h is too small), causing the navigation to stay visible
					// so i just use the maximum value
					if (h > this.max_translate_top) {
						this.max_translate_top = h
					} else {
						h = this.max_translate_top
					}
					this.$nav_el.css('transform', 'translate(' + x + ',-' + h + 'px)')
				} else {
					var h = window.innerHeight - this.rect.top + navshow_hide_safety_offset
					// on safari mobile, i think because of the top browser bar changing its height when
					// scrolling up and down, sometimes this calculation is off (h is too small), causing the navigation to stay visible
					// so i just use the maximum value
					if (h > this.max_translate_bottom) {
						this.max_translate_bottom = h
					} else {
						h = this.max_translate_bottom
					}
					this.$nav_el.css('transform', 'translate(' + x + ',' + h + 'px)')
				}
			}
		}

		this.$nav_el.addClass('hidden')
	}
}

var init = function () {
	switch (parseInt(layData.nav_amount, 10)) {
		case 1:
			var nav_showhide = new NavShowHide('primary')
			navshowhide_instances = [nav_showhide]
			break
		case 2:
			var nav_showhide = new NavShowHide('primary')
			var nav_showhide_second_menu = new NavShowHide('second_menu')
			navshowhide_instances = [nav_showhide, nav_showhide_second_menu]
			break
		case 3:
			var nav_showhide = new NavShowHide('primary')
			var nav_showhide_second_menu = new NavShowHide('second_menu')
			var nav_showhide_third_menu = new NavShowHide('third_menu')
			navshowhide_instances = [nav_showhide, nav_showhide_second_menu, nav_showhide_third_menu]
			break
		case 4:
			var nav_showhide = new NavShowHide('primary')
			var nav_showhide_second_menu = new NavShowHide('second_menu')
			var nav_showhide_third_menu = new NavShowHide('third_menu')
			var nav_showhide_fourth_menu = new NavShowHide('fourth_menu')
			navshowhide_instances = [nav_showhide, nav_showhide_second_menu, nav_showhide_third_menu, nav_showhide_fourth_menu]
			break
	}
}

jQuery(document).ready(function () {
	init()
})

var get_navshowhide_instances = function () {
	return navshowhide_instances
}

export default get_navshowhide_instances
